module.exports = __webpack_public_path__ + "img/info.ad6c4a52.svg";